__turbopack_context__.v({
  "segmentedControl": "SegmentedControl-module__Iny3Na__segmentedControl",
  "segmentedControlFull": "SegmentedControl-module__Iny3Na__segmentedControlFull",
});
